exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".iFxjz3Amcwj-2VKL3ahFh{padding:0 20px;line-height:48px;border:2px solid #009688;color:#009688;text-transform:uppercase;background-color:transparent;font-size:18px;outline:0;cursor:pointer;-webkit-transition:all .3s ease-in;transition:all .3s ease-in}.iFxjz3Amcwj-2VKL3ahFh:hover{color:#fff;background-color:#009688}", ""]);

// exports
exports.locals = {
	"root": "iFxjz3Amcwj-2VKL3ahFh"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/postcss-loader!./components/load-more-button.css
 ** module id = 1020
 ** module chunks = 0
 **/